import React, { Fragment } from "react";
import { useGeographicalLocations } from "redux/features/countries";
import { Columns, Form } from "react-bulma-components";

const { Control, Select } = Form;

export function PromptLocation({
  location,
  setLocation,
  countryPrompt = "in",
}) {
  const { locationLookup, countries } = useGeographicalLocations();
  const locationProperties = location ? locationLookup[location] : null;
  const countryId = locationProperties ? locationProperties.country_id : null;
  const [locationCountry] = countries.filter((c) => c.id === countryId);
  return (
    <Columns>
      <Columns.Column size={5} className="has-text-right pb-0">
        {countryPrompt}:
      </Columns.Column>
      <Columns.Column size={7} className="pb-0">
        <Control>
          <Select
            value={locationCountry ? locationCountry.symbolic_id : ""}
            onChange={(event) => {
              setLocation(
                (locationLookup[event.target.value] || {}).symbolic_id
              );
            }}
          >
            <option key="" value="">
              - please select country -
            </option>
            {countries.map((country) => (
              <option key={country.id} value={country.symbolic_id}>
                {country.label}
              </option>
            ))}
          </Select>
        </Control>
      </Columns.Column>
      {locationCountry && locationCountry.has_fixed_area_choices ? (
        <Fragment>
          <Columns.Column size={5} className="has-text-right pt-0">
            {locationCountry.administrative_area_terminology}:
          </Columns.Column>
          <Columns.Column size={7} className="pt-0">
            <Control>
              <Select
                value={
                  locationProperties && !locationProperties.isCountry
                    ? location
                    : ""
                }
                onChange={(event) => {
                  setLocation(
                    (locationLookup[event.target.value] || {}).symbolic_id
                  );
                }}
              >
                <option key="" value="">
                  - please select -
                </option>
                {locationCountry.administrative_areas.map((area) => (
                  <option key={area.id} value={area.symbolic_id}>
                    {area.label}
                  </option>
                ))}
              </Select>
            </Control>
          </Columns.Column>
        </Fragment>
      ) : null}
    </Columns>
  );
}
